/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询需要客户端缓存的项目ID
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<number>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/cache/client/products`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
